import { FC } from "react";
import { Body, Title, Subtitle, Wrapper } from "./InfoBox.styled";
import parse from "html-react-parser";

type Props = {
  data: {
    title?: string;
    subHeadline?: string;
    markup?: string;
  };
};

const InfoBox: FC<Props> = ({ data }) => {
  if (!data) {
    return null;
  }

  return (
    <Wrapper>
      <Title>{data?.title}</Title>
      <Subtitle>{data?.subHeadline}</Subtitle>
      <Body>{data?.markup && parse(data.markup)}</Body>
      <br />
    </Wrapper>
  );
};

export default InfoBox;
